import clientConfig from 'clientCommon/config';
export const API_URL = clientConfig.apiEndpoint;
export const API_MOCK_ENABLE = false;
export const API_MOCK_PATH = '/assets/apimocks/';
export const FORCE_ENABLE_WORKER = false;
export const AVATAR_PLACEHOLDER_URL = '/assets/img/avatar_placeholder.png';
